<template>
<div>
  <v-layout row justify-center><v-flex class="pt-4 px-2" xs12 md10>
    <v-layout row wrap justify-center>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-text-field
          label="Name"
          v-model.trim="newTask.name"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-select
          label="Choose Content"
          @blur="sectionNames = getSections(), chosenSection = '', chosenTask = ''"
          v-model="chosenContent"
          :items="contentNames"
          hide-details
        ></v-select>
      </v-flex>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-select
          label="Choose Sections"
          @blur="taskNames = getTasks(), chosenTask = ''"
          v-model="chosenSection"
          :items="sectionNames"
          hide-details
        ></v-select>
      </v-flex>
      <v-flex class="pb-3 px-1" xs12 sm10 md6>
        <v-select
          label="Choose Task"
          v-model="chosenTask"
          :items="taskNames"
          hide-details
        ></v-select>
      </v-flex>
      <v-flex class="pb-3 text-xs-center" xs12>
        <v-btn
          @click.native="canCreate"
          color="success"
          :loading="updating"
          :disabled="updating"
          depressed
          large
        ><b>Update</b></v-btn>
        <v-btn
          @click.native="popup.type = 'Resetting', popup.show = true"
          color="error"
          flat
          large
        ><b>Reset</b></v-btn>
      </v-flex>
      <v-flex class="px-2 py-4" xs12 md10>
        <v-divider></v-divider>
      </v-flex>
      <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
        <v-btn @click.native="setupDeleteTask()" color="error" :disabled="deleting" :loading="deleting" large>Delete Task</v-btn>
      </v-flex>
    </v-layout>
  </v-flex></v-layout>

  <r-task-popup
    :popup="popup"
    :task-data="newTask"
    :deleting-data="toDelete"
  ></r-task-popup>
</div>
</template>

<script>
import TaskPopup from './TaskPopup.vue'
import {contentEvent} from '../../main'
export default {
  components: {
    rTaskPopup: TaskPopup
  },
  data: () => ({
    loading: false,
    updating: false,
    deleting: false,
    taskData: {},
    toDelete: {},
    allTags: [],
    newTask: {},
    content: [],
    contentNames: [],
    sections: [],
    sectionNames: [],
    tasks: [],
    taskNames: [],
    chosenContent: '',
    chosenSection: '',
    chosenTask: '',
    popup: {
      show: false,
      type: ''
    }
  }),
  beforeMount () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('updateTask', () => {
      this.updateTask()
    })
    contentEvent.$on('reset', () => {
      this.load()
    })
    contentEvent.$on('delete', () => {
      this.deleteTask()
    })
  },
  methods: {
    load () {
      this.loading = true
      this.content = this.$store.getters.content
      for (let c of this.content) {
        this.contentNames.push(c.name)
      }
      this.contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      this.sections = this.$store.getters.sectionByContent(this.contentData.key)
      for (let s of this.sections) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      this.tasks = this.$store.getters.taskBySection(this.sectionData.key)
      for (let t of this.tasks) {
        if (t.url === this.$route.params.taskUrl) this.taskData = t
      }
      this.resetNewTask()
      this.loading = false
    },
    resetNewTask () {
      this.newTask = {
        ...this.taskData
      }
      let task = this.$store.getters.taskByKey(this.newTask.linkedTaskKey)
      this.chosenTask = task.name
      let section = this.$store.getters.sectionByKey(task.sectionKey)
      this.chosenSection = section.name
      let content = this.$store.getters.contentByKey(section.contentKey)
      this.chosenContent = content.name
      this.sectionNames = this.getSections()
      this.taskNames = this.getTasks()
    },
    changed () {
      let name = this.newTask.name.toLowerCase() !== this.taskData.name.toLowerCase()
      let linkedTaskKey = this.newTask.linkedTaskKey !== this.taskData.linkedTaskKey
      return name || linkedTaskKey
    },
    canCreate () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.chosenContent === '' || this.chosenSection === '' || this.chosenTask === '') {
        appMsg.msg = 'Please choose a task to link to this task'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      this.newTask.linkedTaskKey = this.getLinkedTaskKey()
      if (this.changed()) {
        if (this.newTask.name === '') {
          appMsg.msg = 'Please enter a name for the section'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.name.toLowerCase() === 'create') {
          appMsg.msg = 'Please use a different name; that name is reserved.'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        }
        if (this.newTask.name.toLowerCase() !== this.taskData.name.toLowerCase()) {
          const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
          let sectionData = {}
          for (let s of this.$store.getters.sectionByContent(contentData.key)) {
            if (s.url === this.$route.params.sectionUrl) sectionData = s
          }
          let tasks = this.$store.getters.taskBySection(sectionData.key)
          for (let t of tasks) {
            if (this.newTask.name.toLowerCase() === t.name.toLowerCase()) {
              appMsg.msg = 'That task name already exists in this section'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        }
        this.popup = {
          show: true,
          type: 'Updating Task'
        }
      } else {
        appMsg.msg = 'No changed detected'
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateTask () {
      this.updating = true
      let nameChanged = this.newTask.name !== this.taskData.name
      if (nameChanged) {
        this.newTask.url = this.$store.getters.formatUrl(this.newTask.name)
      }
      this.$store.dispatch('updateTask', this.newTask).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.taskData.name + ' test updated'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.updating = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
      })
    },
    getSections () {
      let names = []
      if (this.chosenContent.length > 0) {
        for (let c of this.content) {
          if (c.name === this.chosenContent) {
            for (let s of this.$store.getters.sectionByContent(c.key)) {
              names.push(s.name)
            }
          }
        }
      }
      let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
      names.sort(collator.compare)
      return names
    },
    getTasks () {
      let names = []
      if (this.chosenContent.length > 0) {
        for (let c of this.content) {
          if (c.name === this.chosenContent) this.sections = this.$store.getters.sectionByContent(c.key)
        }
        for (let s of this.sections) {
          if (s.name === this.chosenSection) this.tasks = this.$store.getters.taskBySection(s.key)
        }
        for (let t of this.tasks) {
          if (t.type !== 'Linking') names.push(t.name)
        }
      }
      let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'})
      names.sort(collator.compare)
      return names
    },
    getLinkedTaskKey () {
      let linkedTaskKey = ''
      for (let c of this.content) {
        if (c.name === this.chosenContent) this.sections = this.$store.getters.sectionByContent(c.key)
      }
      for (let s of this.sections) {
        if (s.name === this.chosenSection) this.tasks = this.$store.getters.taskBySection(s.key)
      }
      for (let t of this.tasks) {
        if (t.name === this.chosenTask) linkedTaskKey = t.key
      }
      return linkedTaskKey
    },
    setupDeleteTask () {
      this.toDelete = {...this.taskData}
      this.popup = {
        show: true,
        type: 'Deleting Task'
      }
    },
    deleteTask () {
      this.deleting = true
      const taskName = this.toDelete.name
      this.$store.dispatch('deleteTask', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: taskName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/EditLinked.vue